import React from "react";
import { Icon } from "../core/Icon.jsx";

// Der Eintrag unter dem Zeiger hebt sich über .erp-menu-item in tokens/base.css hervor.
// Ein Menü ist der Ort, an dem das Kennzeichen im Zustand am sichersten hängen bleibt:
// Es schließt sich beim Klick, das mouseleave kommt nie.
export function ContextMenu({ items = [], width = 230, style = {} }) {
  return (
    <div style={{ width, background: "var(--bg-pop)", border: "1px solid var(--line-c)", borderRadius: "var(--r-popover)", boxShadow: "var(--shadow-popover)", padding: 4, ...style }}>
      {items.map((m, i) => m.divider ? (
        <div key={"d" + i} style={{ height: 1, background: "var(--line-f)", margin: "4px 0" }} />
      ) : (
        <div key={m.label} onClick={m.onClick} className="erp-menu-item"
          style={{ display: "flex", alignItems: "center", gap: 10, padding: "7px 10px", borderRadius: "var(--r-tile)", background: "var(--menu-item-hot-bg, transparent)", cursor: "pointer", fontSize: "var(--fs-13)", color: m.danger ? "var(--ac-red)" : "var(--fg-3)" }}>
          {m.icon ? <Icon name={m.icon} size={14} /> : null}
          <span style={{ flex: 1 }}>{m.label}</span>
          {m.hint ? <span style={{ fontSize: "var(--fs-11)", color: "var(--fg-9)" }}>{m.hint}</span> : null}
          {m.submenu ? <Icon name="chevron-right" size={13} style={{ color: "var(--fg-9)" }} /> : null}
        </div>
      ))}
    </div>
  );
}
